export default __webpack_public_path__ + "static/media/whatWeFaceZh.9a07d270.png";